/* eslint-disable react/jsx-handler-names */
import React, { useContext, useState } from 'react'

import Button from '~/components/common/button'
import { ColumnFlex } from '~/components/common/containers'
import { Context } from '../context'
import Input from '@8x8/oxygen-input'
import { KEY_CODES } from '~/core/constants'
import Modal from '~/components/common/modal'
import ModalHeader from '~/components/common/modal-header'
import { showErrorNotification } from '~/core/ui'
import styled from 'styled-components'
import { translate } from '~/core/translate'
import { validateCoupon } from '../../services/api'

const StyledButton = styled(Button)`
  min-width: 80px;
  margin-left: 16px;
`

const Content = styled(ColumnFlex)`
  padding: 16px;
  justify-content: left;
`

const StyledInput = styled(Input)`
  margin-top: 4px;
  margin-bottom: 0;
`

const ButtonsWrapper = styled.div`
  margin-top: 32px;
  margin-left: auto;
`

const AddCouponDialog = () => {
  const [coupon, setCoupon] = useState('')
  const [saving, setSaving] = useState(false)
  const context = useContext(Context)

  const save = async () => {
    setSaving(true)

    try {
      const response = await validateCoupon(coupon)
      context.setCoupon(response)

      context.hideDialog()
    } catch (err) {
      showErrorNotification('Failed to validate coupon')
    }

    setSaving(false)
  }

  const onKeyPress = e => {
    if (e.charCode === KEY_CODES.ENTER) {
      save()
    }
  }

  return (
    <Modal size='small' visible width='375px' height='auto'>
      <ModalHeader
        title={translate('add_coupon')}
        onClose={context.hideDialog}
      />
      <Content>
        <StyledInput
          placeholder={translate('coupon_key')}
          value={coupon}
          onChange={evt => setCoupon(evt.target.value)}
          onKeyPress={onKeyPress}
        />
        <ButtonsWrapper>
          <StyledButton isDisabled={!coupon || saving} onClick={save}>{translate('save')}</StyledButton>
          <StyledButton disabled={saving} secondary onClick={context.hideDialog}>
            {translate('cancel')}
          </StyledButton>
        </ButtonsWrapper>
      </Content>
    </Modal>
  )
}

export default AddCouponDialog
